<template>
  <ModalBase :show="show" @close="close()">
    <h3 class="modal-heading">Nästan klart!</h3>
    <span class="alert alert-info">
      <i class="fas fa-info"></i><strong>Aktivera annonsen!</strong><br><br>Din annons har skapats men den behöver aktiveras genom länken som skickats till din epostadress.<br><br><em>Fick du inte mejlet? Kolla så att det inte hamnat i skräpposten.</em>
    </span>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/ModalBase.vue'

export default {
  name: 'SuccessItemCreate',
  props: ['show'],
  components: {
    ModalBase
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
